import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PlannerTaskInfo } from './types';

interface ExistingTaskPickerProps {
    tasks: PlannerTaskInfo[];
    getFolderName: (folderId: string) => string;
    getCollectionName: (collectionId: string) => string;
    onSelect: (taskInfo: PlannerTaskInfo) => void;
    onClose: () => void;
}

export const ExistingTaskPicker: React.FC<ExistingTaskPickerProps> = ({
    tasks,
    getFolderName,
    getCollectionName,
    onSelect,
    onClose,
}) => {
    const { t } = useTranslation();
    const [search, setSearch] = useState('');
    const matchingTasks = useMemo(() => {
        const normalizedSearch = search.trim().toLowerCase();
        if (!normalizedSearch) return tasks;

        return tasks.filter(({ task }) => (task.title || task.task || '').toLowerCase().includes(normalizedSearch));
    }, [search, tasks]);

    return (
        <div className="existing-task-picker-overlay" onClick={onClose}>
            <div className="existing-task-picker" role="dialog" aria-modal="true" onClick={(event) => event.stopPropagation()}>
                <div className="existing-task-picker-header">
                    <h3>{t('dailyPlanner.selectExistingTask')}</h3>
                    <button type="button" onClick={onClose} aria-label={t('dailyPlanner.cancel')}>×</button>
                </div>
                <input
                    type="search"
                    value={search}
                    onChange={(event) => setSearch(event.target.value)}
                    placeholder={t('dailyPlanner.searchTasks')}
                    autoFocus
                />
                {matchingTasks.length === 0 ? (
                    <p className="existing-task-picker-empty">{t('dailyPlanner.noUnscheduledTasks')}</p>
                ) : (
                    <div className="existing-task-picker-list">
                        {matchingTasks.map((taskInfo) => (
                            <button type="button" key={taskInfo.task.id} onClick={() => onSelect(taskInfo)}>
                                <strong>{taskInfo.task.title || taskInfo.task.task}</strong>
                                <span>{getFolderName(taskInfo.folderId)} / {getCollectionName(taskInfo.collectionId)}</span>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};
